import '@/App.css';
import '@/index.css';
import { useEffect } from 'react';
import axios from 'axios';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { toast } from 'sonner';
import HomePage from '@/pages/HomePage';
import BooksPage from '@/pages/BooksPage';
import BookDetailPage from '@/pages/BookDetailPage';
import GiftsPage from '@/pages/GiftsPage';
import GiftDetailPage from '@/pages/GiftDetailPage';
import SearchPage from '@/pages/SearchPage';
import AboutPage from '@/pages/AboutPage';
import AdminLogin from '@/pages/admin/AdminLogin';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import AdminBooks from '@/pages/admin/AdminBooks';
import AdminGifts from '@/pages/admin/AdminGifts';
import AdminCategories from '@/pages/admin/AdminCategories';
import Layout from '@/components/Layout';
import AdminLayout from '@/components/AdminLayout';

function App() {
  useEffect(() => {
    const interceptorId = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const isAuthExpired = error.response?.status === 401;
        const inAdmin = window.location.pathname.startsWith('/admin');
        if (isAuthExpired && inAdmin && !window.location.pathname.includes('/admin/login')) {
          localStorage.removeItem('admin_token');
          toast.error('Your session expired. Please sign in again.');
          setTimeout(() => {
            window.location.href = '/admin/login';
          }, 800);
        }
        return Promise.reject(error);
      }
    );
    return () => axios.interceptors.response.eject(interceptorId);
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="books" element={<BooksPage />} />
          <Route path="books/:id" element={<BookDetailPage />} />
          <Route path="gifts/:category" element={<GiftsPage />} />
          <Route path="gifts/detail/:id" element={<GiftDetailPage />} />
          <Route path="search" element={<SearchPage />} />
          <Route path="about" element={<AboutPage />} />
        </Route>
        
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="books" element={<AdminBooks />} />
          <Route path="gifts" element={<AdminGifts />} />
          <Route path="categories" element={<AdminCategories />} />
        </Route>
      </Routes>
      <Toaster position="top-right" />
    </BrowserRouter>
  );
}

export default App;